import { getNextStaticProps } from "@faustjs/next";
import { client, PageIdType } from "../client";
import { GetStaticPropsContext } from "next";
import {
  JobListingsTable,
  TeamMembersGrid,
  AboutCTA,
  JumpLink,
  FeaturedPost,
  CEOLink,
} from "components";
import { useFeaturedPost, useMenu, useGeneralOptionsSettings } from "hooks";
import Layout from "layouts/main";

export default function Page() {
  const { useQuery, usePage } = client;

  const options = useGeneralOptionsSettings();
  const ceoLink = options?.generalSettings?.ceoLink;
  const page = usePage({
    id: `/about`,
    idType: PageIdType.URI,
  });
  const jobs = useQuery().jobs().nodes;
  const teamMembers = useQuery().teamMembers({ first: 30 }).nodes;
  const featuredPost = useFeaturedPost();
  const headerLinks = useMenu("PRIMARY");
  const footerLinks = useMenu("FOOTER");
  return (
    <Layout page={page} headerLinks={headerLinks} footerLinks={footerLinks}>
      <JumpLink />
      <TeamMembersGrid teamMembers={teamMembers} />
      <AboutCTA aboutCTA={page?.aboutCTA} />
      <JobListingsTable jobs={jobs} />
      <FeaturedPost post={featuredPost} />
      <CEOLink
        className="h-[70px] w-[271px] fixed bottom-5 right-5 z-50"
        link={ceoLink}
      />
    </Layout>
  );
}

export async function getStaticProps(context: GetStaticPropsContext) {
  return getNextStaticProps(context, {
    Page,
    client,
  });
}
